import {
  Admin,
  AdminBilling,
  AdminBooking,
  AdminBookingInvoice,
  AdminCheckout,
  AdminMembers,
  AdminProducts,
  AdminProfile,
  AdminReports,
  AdminReportsOverview,
  AdminSettings
} from "@/modules/admin";

import { ConciergeDashboard, ConciergeEvents } from "@/modules/concierge";

import NewBooking from "@/components/booking/NewBooking";

import Logs from "@/components/Logs";

export default [
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    redirect: "/admin/dashboard",
    meta: {
      isAuthorized: true,
      isAdmin: true
    },
    children: [
      {
        path: "dashboard",
        name: "Bookings",
        component: ConciergeDashboard
      },
      {
        path: "members",
        name: "members",
        component: AdminMembers
      },
      {
        path: "members/:id/checkout",
        name: "admin-checkout",
        component: AdminCheckout
      },
      {
        path: "events",
        name: "events",
        component: ConciergeEvents
      },
      {
        path: "products",
        name: "products",
        component: AdminProducts
      },
      {
        path: "settings",
        name: "settings",
        component: AdminSettings
      },
      {
        path: "logs",
        name: "Activity",
        component: Logs
      },
      {
        path: "booking/:id",
        component: AdminBooking,
        children: [
          // { /** Hide old booking route */
          //   path: "",
          //   name: "admin-booking-old",
          //   component: AdminBookingOrder
          // },
          {
            path: "invoice/:invoiceId",
            name: "admin-invoice",
            component: AdminBookingInvoice
          },
          {
            path: "",
            name: "Admin Booking",
            component: NewBooking
          }
          // { /** Disable category route */
          //   path: "category/:categoryId",
          //   name: "admin-booking",
          //   component: NewBooking
          // }
        ]
      },
      {
        path: "profile",
        name: "profile",
        component: AdminProfile
      },
      {
        path: "billing",
        name: "billing",
        component: AdminBilling
      },
      {
        path: "reports",
        component: AdminReports,
        children: [
          {
            path: "/",
            name: "reports",
            component: AdminReportsOverview
          }
        ]
      }
    ]
  }
];
